import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "./config/API";

function UserRegistration() {
  const navigate = useNavigate();

  const [showPopup, setShowPopup] = useState(false);

  const loggedUser = JSON.parse(localStorage.getItem("user"));
  const pgName = loggedUser?.pgName || "";

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    contactNo: "",
    alternativeContactNo: "",
    emailId: "",
    pgName: pgName,
    aadharCardNo: "",
    userDataOfBirth: "", // ✅ NEW
    userStayingType: "",
    stayingDaysType: "",
    fromDate: "",
    toDate: "",
    isSnoringIssue: "No",
  });

  const [errors, setErrors] = useState({
    contactNo: "",
    alternativeContactNo: "",
    aadharCardNo: "",
    emailId: "",
    userDataOfBirth: "", // ✅ NEW
  });

  const [loading, setLoading] = useState(false);
  const [contactExists, setContactExists] = useState(false);

  // ================= EMAIL VALIDATION (ONLY GMAIL) =================
  const isValidEmail = (email) => /^[a-zA-Z0-9._%+-]+@gmail\.com$/.test(email);

  // ================= DOB VALIDATION DD-MM-YYYY =================
  const isValidDOB = (dob) => {
    return /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/.test(dob);
  };

  // ================= HANDLE CHANGE =================
  const handleChange = async (e) => {
    const { name, value } = e.target;

    let updatedForm = { ...form };

    // ================= AADHAR FORMAT =================
    if (name === "aadharCardNo") {
      let digits = value.replace(/\D/g, "").substring(0, 16);
      updatedForm.aadharCardNo = digits.replace(/(\d{4})(?=\d)/g, "$1 ").trim();
    }

    // ================= CONTACT NUMBERS =================
    if (name === "contactNo" || name === "alternativeContactNo") {
      const digits = value.replace(/\D/g, "").substring(0, 10);
      updatedForm[name] = digits;
    }

    // ================= DOB (ONLY TEXT FORMAT) =================
    if (name === "userDataOfBirth") {
      let val = value.replace(/\D/g, ""); // only numbers

      if (val.length > 2 && val.length <= 4) {
        val = val.slice(0, 2) + "-" + val.slice(2);
      } else if (val.length > 4) {
        val = val.slice(0, 2) + "-" + val.slice(2, 4) + "-" + val.slice(4, 8);
      }

      updatedForm.userDataOfBirth = val;
    }

    // ================= EMAIL =================
    if (name === "emailId") {
      updatedForm.emailId = value;
    }

    // ================= OTHER FIELDS =================
    if (
      ![
        "aadharCardNo",
        "contactNo",
        "alternativeContactNo",
        "userDataOfBirth",
        "emailId",
      ].includes(name)
    ) {
      updatedForm[name] = value;
    }

    // ================= TENANT AUTO MONTH =================
    if (name === "userStayingType" && value === "Tenant") {
      updatedForm.stayingDaysType = "Month";
    }

    setForm(updatedForm);

    // ================= VALIDATIONS =================
    let updatedErrors = { ...errors };

    if (name === "emailId") {
      updatedErrors.emailId = isValidEmail(value)
        ? ""
        : "Only @gmail.com email allowed";
    }

    if (name === "contactNo") {
      updatedErrors.contactNo =
        updatedForm.contactNo.length === 10 ? "" : "10 digits required";
    }

    if (name === "alternativeContactNo") {
      updatedErrors.alternativeContactNo =
        updatedForm.alternativeContactNo.length === 10
          ? ""
          : "10 digits required";
    }

    if (name === "aadharCardNo") {
      updatedErrors.aadharCardNo =
        updatedForm.aadharCardNo.replace(/\s/g, "").length === 12
          ? ""
          : "12 digits required";
    }

    if (name === "userDataOfBirth") {
      updatedErrors.userDataOfBirth = isValidDOB(value)
        ? ""
        : "Format must be DD-MM-YYYY";
    }

    setErrors(updatedErrors);

    // ================= CHECK CONTACT EXISTS =================
    if (name === "contactNo" && updatedForm.contactNo.length === 10) {
      try {
        const response = await fetch(
          `http://localhost:9777/user/checkUserExistsByContactNo?contactNo=${updatedForm.contactNo}`,
        );

        const data = await response.json();
        setContactExists(data?.data === true);
      } catch (err) {
        console.error(err);
      }
    }
  };

  // ================= SUBMIT =================
  const handleSubmit = async () => {
    if (form.contactNo.length !== 10) return alert("Invalid Contact");
    if (form.alternativeContactNo.length !== 10)
      return alert("Invalid Alternate Contact");
    if (form.aadharCardNo.replace(/\s/g, "").length !== 12)
      return alert("Invalid Aadhar");
    if (!isValidEmail(form.emailId)) return alert("Only @gmail.com allowed");
    if (!isValidDOB(form.userDataOfBirth))
      return alert("DOB must be DD-MM-YYYY");

    setLoading(true);

    const payload = {
      firstName: form.firstName,
      lastName: form.lastName,
      contactNo: Number(form.contactNo),
      alternativeContactNo: Number(form.alternativeContactNo),
      emailId: form.emailId,
      createdBy: "john@example.com",
      pgName: form.pgName,
      aadharCardNo: Number(form.aadharCardNo.replace(/\s/g, "")),
      userStayingType: form.userStayingType,
      userStayingDaysType: form.stayingDaysType,
      bedNeedFromDate: form.fromDate,
      bedNeedToDate: form.toDate,
      isSnoringIssue: form.isSnoringIssue,
      userDataOfBirth: form.userDataOfBirth, // ✅ NEW FIELD
    };

    try {
      const user = JSON.parse(localStorage.getItem("user"));

      const response = await fetch(`${API.V1}/user/registration`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.jwtToken}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok && data.statusCode === 200) {
        setShowPopup(true);

        const userRegisterId =
          data?.data?.userRegisterId || data?.data?.userRegistrationId;

        setTimeout(() => {
          navigate("/userBedBooking", {
            state: {
              userRegisterId,
              firstName: form.firstName,
              lastName: form.lastName,
              emailId: form.emailId,
              contactNo: form.contactNo,
              pgName: form.pgName,
            },
          });
        }, 2000);
      } else if (response.status === 401) {
        alert("Session expired. Please login again.");

        localStorage.clear();

        navigate("/");
      } else {
        alert(data?.message || "Registration Failed ❌");
      }
    } catch (error) {
      console.error("Registration Error:", error);
      alert("Server Error ❌");
    }

    setLoading(false);
  };

  // ================= UI =================
  return (
    <div style={styles.container}>
      {showPopup && (
        <div style={styles.popup}>✅ User Registered Successfully</div>
      )}

      <div style={styles.card}>
        <h1 style={styles.title}>🏠 User Registration</h1>

        <div style={styles.grid}>
          {/* FIRST NAME */}
          <div style={styles.fieldBlue}>
            <label style={styles.label}>First Name</label>
            <input
              style={styles.input}
              name="firstName"
              value={form.firstName}
              onChange={handleChange}
            />
          </div>

          {/* LAST NAME */}
          <div style={styles.fieldPurple}>
            <label style={styles.label}>Last Name</label>
            <input
              style={styles.input}
              name="lastName"
              value={form.lastName}
              onChange={handleChange}
            />
          </div>

          {/* CONTACT */}
          <div style={styles.fieldGreen}>
            <label style={styles.label}>Contact Number</label>
            <input
              style={styles.input}
              name="contactNo"
              value={form.contactNo}
              onChange={handleChange}
              maxLength={10}
            />
          </div>

          {/* ALT CONTACT */}
          <div style={styles.fieldYellow}>
            <label style={styles.label}>Alternate Contact</label>
            <input
              style={styles.input}
              name="alternativeContactNo"
              value={form.alternativeContactNo}
              onChange={handleChange}
              maxLength={10}
            />
          </div>

          {/* EMAIL */}
          <div style={styles.fieldPink}>
            <label style={styles.label}>Email ID</label>
            <input
              style={styles.input}
              name="emailId"
              value={form.emailId}
              onChange={handleChange}
            />
          </div>

          {/* PG */}
          <div style={styles.fieldOrange}>
            <label style={styles.label}>PG Name</label>
            <input
              style={styles.input}
              name="pgName"
              value={form.pgName}
              readOnly
            />
          </div>

          {/* DOB (NO CALENDAR) */}
          <div style={styles.fieldSky}>
            <label style={styles.label}>Date of Birth (DD-MM-YYYY)</label>
            <input
              style={styles.input}
              name="userDataOfBirth"
              value={form.userDataOfBirth}
              onChange={handleChange}
              placeholder="DD-MM-YYYY"
              maxLength={10}
            />
          </div>

          {/* AADHAR */}
          <div style={styles.fieldCyan}>
            <label style={styles.label}>Aadhar Card No</label>
            <input
              style={styles.input}
              name="aadharCardNo"
              value={form.aadharCardNo}
              onChange={handleChange}
              maxLength={14}
            />
          </div>

          {/* USER TYPE */}
          <div style={styles.fieldIndigo}>
            <label style={styles.label}>User Staying Type</label>
            <select
              style={styles.input}
              name="userStayingType"
              value={form.userStayingType}
              onChange={handleChange}
            >
              <option value="">Select</option>
              <option value="Guest">Guest</option>
              <option value="Tenant">Tenant</option>
            </select>
          </div>
        </div>

        <button style={styles.button} onClick={handleSubmit} disabled={loading}>
          {loading ? "Submitting..." : "Submit Registration"}
        </button>
      </div>
    </div>
  );
}

export default UserRegistration;

// ================= STYLES =================

const styles = {
  container: {
    minHeight: "100vh",

    display: "flex",

    justifyContent: "center",

    alignItems: "center",

    background: "linear-gradient(135deg,#e0f2fe,#f8fafc,#eef2ff)",

    padding: "25px",

    fontFamily: "Segoe UI, sans-serif",
  },

  popup: {
    position: "fixed",

    top: "25px",

    right: "25px",

    background: "#16a34a",

    color: "#fff",

    padding: "18px 28px",

    borderRadius: "14px",

    fontWeight: "700",

    fontSize: "16px",

    boxShadow: "0 10px 25px rgba(22,163,74,0.35)",

    zIndex: 999,
  },

  card: {
    width: "100%",

    maxWidth: "1200px",

    background: "#ffffff",

    padding: "40px",

    borderRadius: "22px",

    boxShadow: "0 15px 45px rgba(0,0,0,0.12)",
  },

  title: {
    textAlign: "center",

    fontSize: "34px",

    fontWeight: "800",

    marginBottom: "30px",

    color: "#0f172a",
  },

  grid: {
    display: "grid",

    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",

    gap: "20px",
  },

  label: {
    display: "block",

    marginBottom: "8px",

    fontWeight: "700",

    color: "#1e293b",

    fontSize: "15px",
  },

  input: {
    width: "100%",

    padding: "14px",

    borderRadius: "12px",

    border: "none",

    outline: "none",

    background: "rgba(255,255,255,0.9)",

    fontSize: "15px",

    boxSizing: "border-box",
  },

  fieldBlue: {
    background: "#dbeafe",

    padding: "16px",

    borderRadius: "18px",
  },

  fieldPurple: {
    background: "#ede9fe",

    padding: "16px",

    borderRadius: "18px",
  },

  fieldGreen: {
    background: "#dcfce7",

    padding: "16px",

    borderRadius: "18px",
  },

  fieldYellow: {
    background: "#fef9c3",

    padding: "16px",

    borderRadius: "18px",
  },

  fieldPink: {
    background: "#fce7f3",

    padding: "16px",

    borderRadius: "18px",
  },

  fieldOrange: {
    background: "#ffedd5",

    padding: "16px",

    borderRadius: "18px",
  },

  fieldSky: {
    background: "#e0f2fe",

    padding: "16px",

    borderRadius: "18px",
  },

  fieldCyan: {
    background: "#cffafe",

    padding: "16px",

    borderRadius: "18px",
  },

  fieldIndigo: {
    background: "#e0e7ff",

    padding: "16px",

    borderRadius: "18px",
  },

  fieldDate: {
    background: "#ede9fe",

    padding: "16px",

    borderRadius: "18px",
  },

  existsText: {
    marginTop: "8px",

    color: "#dc2626",

    fontWeight: "700",

    fontSize: "13px",
  },

  errorText: {
    marginTop: "6px",

    color: "#dc2626",

    fontSize: "13px",

    fontWeight: "700",
  },

  button: {
    marginTop: "35px",

    width: "100%",

    padding: "18px",

    border: "none",

    borderRadius: "16px",

    background: "linear-gradient(45deg,#2563eb,#06b6d4)",

    color: "#fff",

    fontSize: "18px",

    fontWeight: "800",

    cursor: "pointer",

    boxShadow: "0 12px 25px rgba(37,99,235,0.3)",
  },
};
